import React from "react";
import Icon, { IconName } from "./Icon";

export interface StatChipProps {
  kind: "stars" | "coins" | "moonrocks" | "streak" | "custom";
  value: React.ReactNode;
  suffix?: React.ReactNode;
  icon?: IconName;
  /** Image icon (S3 art) instead of the SVG set. */
  iconSrc?: string;
  onClick?: () => void;
  ariaLabel?: string;
  size?: "sm" | "md";
  className?: string;
}

const ICONS: Record<StatChipProps["kind"], IconName> = { stars: "star", coins: "coin", moonrocks: "moonrock", streak: "fire", custom: "sparkle" };

/** Icon + number (+ optional suffix like "Full"). Used in the HUD, shop balance strip and dialogs. Forwards its ref so a Popover can anchor to it. */
const StatChip = React.forwardRef<HTMLElement, StatChipProps>(function StatChip({ kind, value, suffix, icon, iconSrc, onClick, ariaLabel, size = "md", className = "" }, ref) {
  const Tag: any = onClick ? "button" : "div";
  return (
    <Tag
      ref={ref}
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`mr-stat mr-stat--${kind} mr-stat--${size} ${className}`}
      aria-label={ariaLabel}
    >
      <span className="mr-stat__icon" aria-hidden="true">
        {iconSrc ? <img src={iconSrc} alt="" /> : <Icon name={icon || ICONS[kind]} size={size === "sm" ? 16 : 20} filled={kind !== "custom"} />}
      </span>
      <span className="mr-stat__value">{value}</span>
      {suffix ? <span className="mr-stat__suffix">{suffix}</span> : null}
    </Tag>
  );
});

export default StatChip;
